import React from "react"

import moment from "moment"

import {withRouter} from "react-router-dom";

import BaseTable from "./BaseTable"
import PillCell from "./cells/PillCell";

import General from '../../../utils/General'
import Currency from "../../../utils/Currency";

class CashoutsTable extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      loadingAccount: true,
      region: props.region,
      companyProcessor: props.companyProcessor,
    }

    this.table = React.createRef()
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps, () => this._refresh())
  }

  _refresh() {
    this.table.current.refresh()
  }

  _getColumns() {
    return [
      {
        Header: 'Created At',
        id: 'created_at',
        width: 130,
        accessor: payout => moment(payout.created_at).format('DD MMM YYYY')
      },
      {
        Header: 'Created By',
        id: 'created_by',
        Cell: rowInfo => {
          let cashout = rowInfo.original

          const companyName = cashout.company_processor.company.name
          const name = `${cashout.created_by.first_name} ${cashout.created_by.last_name}`

          return (
            <div className="d-flex align-items-center">
              <div>
                <div className="text-dark-75 font-weight-bold line-height-sm">
                  {companyName}
                </div>
                <div className="font-size-sm text-dark-50">{name}</div>
              </div>
            </div>
          )
        }
      },
      {
        Header: 'Amount',
        id: 'amount',
        width: 150,
        Cell: rowInfo => {
          let payout = rowInfo.original
          return Currency.format(payout.currency.symbol, payout.amount)
        }
      },
      {
        Header: 'Association Commission',
        id: 'amount',
        width: 250,
        Cell: rowInfo => {
          let payout = rowInfo.original
          return Currency.format(payout.currency.symbol, payout.association_commission)
        }
      },
      {
        Header: 'Platform Commission',
        id: 'amount',
        width: 250,
        Cell: rowInfo => {
          let payout = rowInfo.original
          return Currency.format(payout.currency.symbol, payout.platform_commission)
        }
      },
      {
        Header: 'Status',
        id: 'status',
        width: 120,
        Cell: rowInfo => {
          let payout = rowInfo.original

          let className = 'label-light-primary'
          if(payout.status === 'completed'){
            className = 'label-light-success'
          }else if(payout.status === 'failed'){
            className = 'label-light-danger'
          }else if(payout.status === 'pending'){
            className = 'label-light-warning'
          }

          return (
            <PillCell
              text={General.snakeCaseToTitleCase(payout.status)}
              className={className}
            />
          )
        }
      },
      {
        Header: 'Reason',
        id: 'failure_reason',
        Cell: rowInfo => {
          let payout = rowInfo.original

          return General.camelCaseToTitleCase(payout.failure_reason || "")
        }
      },
    ]
  }

  render() {
    const columns = this._getColumns()

    return (
      <div>
        <BaseTable
          ref={this.table}
          endpoint={`${window.Api.Cashouts}`}
          noDataMessage={"No Cashout Found"}
          title={this.props.title}
          columns={columns}
          showExport={false}
          showFilter={false}
          showSearch={false}
          showObjectFilter={false}
          defaultSorted={[
            {
              id: "created_at",
              desc: true
            }
          ]}
        />
      </div>
    )
  }
}

export default withRouter(CashoutsTable);
